<template>
    <v-tooltip bottom>
        <template #activator="{ on }">
            <v-btn :text="text" v-on="on">
                <v-icon left>mdi-cancel</v-icon>
                {{ label || $t('no-permission-button.no-permission') }}
            </v-btn>
        </template>
        <span>{{ $t('no-permission-button.insufficient-permission') }}</span>
    </v-tooltip>
</template>

<script>
export default {
    props: ['text', 'label']
};
</script>
